export const ROLE_STATUS_ENABLED = "ENABLED";
export const ROLE_STATUS_DISABLED = "DISABLED";

export const ROLE_STATUSES = [ROLE_STATUS_ENABLED, ROLE_STATUS_DISABLED];
